<template>
    <div class="h-full">
        <div class="sas-container">
            <NewComments messageType="12" :siteId="siteId"></NewComments>
            <div class="h-full bg-white">
                <div class="row row2">
                <div class="left">
                    <div class="status" v-for="(v, k) in statusOption" :key="k">
                        <div class="icon"><img :src="getIconSvg(v.icon)" /></div>
                        <div class="text">{{ $t(v.label) }}</div>
                    </div>
                </div>
                <div class="right">
                    <GuidanceTooltip class="tip" v-show="getUser.userType == '1'" :content="$t('sas_tip_html')" :size="20" :iconSize="15" :jumpLink="$t('sas_tip_link')"></GuidanceTooltip>
                    <div class="split"></div>
                    <div :class="['table-column-control', anyHidden ? 'table-column-control-active' : '']" @click="onTableColumnControlClick">
                        <div class="icon"><img src="@/assets/img/icon-table-setting.svg" width="100%" class="table-setting-icon" /></div>
                        <div class="text">{{ $t('table_columns_display_btn') }}</div>
                    </div>
                    <div class="split"></div>
                    <div :class="['clean-filter', (milestoneQueryList.length > 0||this.getEntityIds.length!==this.entityDataTotalSize||this.tableFilter.fileName||this.tableFilter.startCommentDate) ? 'clean-filter-active' : '']" @click="clearFilter">
                        <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                        {{ $t('clear_filter') }}
                    </div>
                </div>
            </div>
            <!--按钮列-->
            <div class="row row2">
                <div class="left">
                    <el-button
                            icon="el-icon-download"
                            class="row2-right-btn wl-green"
                            @click="onBatchDownloadClick"
                            :disabled="tableSelect.show || !hasPermission('download')">
                        {{$t('BATCH_DOWNLOAD')}}
			<GuidanceTooltip
			  backgroundColor="none"
              yellowIcon
              :size="20"
              :iconSize="14"
              :content="$t('setFileAndDownloadTipHtml')"
              :jumpLink="$t('setFileAndDownloadTipLink')"
      
          ></GuidanceTooltip>
                    </el-button>
                </div>
                <div class="right">
                    <el-button
                        v-show="getUser.userType == '1'"
                        icon="el-icon-message"
                        class="row2-right-btn wl-green"
                        @click="onNoticeProgressClick"
                        :disabled="tableSelect.show">
                        {{$t('Notify_Client_About_Report_Progress')}}
                    </el-button>
                    <el-button
                        v-show="getUser.userType == '1'"
                        icon="el-icon-message"
                        class="row2-right-btn wl-green"
                        @click="onNoticeDraftClick"
                        :disabled="tableSelect.show">
                        {{$t('Notify_Client_About_Uploaded_Draft_Reports')}}
                    </el-button>
                    <el-button
                        class="row2-right-btn wl-green svg-btn"
                        @click="onExportClick"
                        :disabled="!hasPermission('download')">
                        <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                        {{ $t('export_statutory_list') }}
                    </el-button>
                    <el-button
                        class="row2-right-btn wl-green svg-btn"
                        @click="onExportFileLogClick"
                        :disabled="tableSelect.show || !hasPermission('download')">
                        <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                        {{ $t('BATCH_export') }}
                    </el-button>
                </div>
            </div>
            <!--表格-->
            <div :class="[tableSelect.show ? 'table-multiselect' : 'table']">
                <el-table
                    :data="tableData"
                    height="100%"
                    border
                    row-class-name="table-row"
                    :cell-style="{height: '100%', padding: '0'}"
                    v-loading="tableLoading"
                    @selection-change="onTableSelectChange"
                    ref="SasTable"
                    :empty-text="$t('TABLE_NO_DATA')"
                >

                    <!-- 选择列 -->
                    <el-table-column type="selection" v-if="tableSelect.show"></el-table-column>

                    <!-- 实体 -->
                    <el-table-column :label="$t('TABLE_HEADER_ENTITIES')" prop="entityName" align="center" min-width="150" show-overflow-tooltip>
                        <template slot="header" slot-scope="scope">
                            <span class="el-dropdown-link">
                                {{ $t('TABLE_HEADER_ENTITIES') }}
                                <i
                                    :class="[
                                        'el-icon-arrow-down',
                                        'table-header-edit-cls',
                                        'th-header-edit',
                                        getEntityIds && getEntityIds.length > 0 && !getEntityIdsSelectAllTag ? 'el-icon-arrow-down-active' : ''
                                        ]"
                                    :title="$t('Filter_per_Entity')"
                                    @click="openEntity"
                                ></i>
                            </span>
                        </template>
                    </el-table-column>

                    <!-- 里程碑 循环 -->
                    <el-table-column
                        v-for="(v, k) in tableColumns.filter(v => v.show)"
                        :key="k"
                        v-show="v.show">
                        <!-- 一级里程碑名 -->
                        <template #header>
                            <div class="level1-table-header">
                                <div class="level1-table-header-text" v-html="v.milestoneName"></div>
                                <div class="fold-btn" @click="switchCollapse(v, v.collapse)">
                                    <el-tooltip v-show="v.collapse" class="item" effect="dark" :content="$t('unfold')" placement="top">
                                        <i class="el-icon-plus"></i>
                                    </el-tooltip>
                                    <el-tooltip v-show="!v.collapse" class="item" effect="dark" :content="$t('fold')" placement="top">
                                        <i class="el-icon-minus"></i>
                                    </el-tooltip>
                                </div>
                            </div>
                        </template>
                        <!-- 如果折叠了，一级表头就显示个150px的空壳 -->
                        <template v-if="v.collapse">
                            <el-table-column width="150"></el-table-column>
                        </template>

                        <!-- 二级里程碑 -->
                        <el-table-column
                            v-else
                            v-for="(vv, kk) in v.childMilestoneBO.filter(v => v.show)"
                            :key="kk"
                            :width="vv.targetTimeSelected ? 250 : 150"
                            align="center"
                            v-show="vv.show">

                            <template #header>
                                <div class="table-level2-header">
                                    <!-- 里程碑名 -->
                                    <el-tooltip :disabled="!vv.showTableColumnTooltip" placement="top" effect="light">
                                        <div slot="content" v-html="vv.milestoneName"></div>
                                        <div :class="['table-level2-label']" @mouseover="calcShowTableColumnTooltip && calcShowTableColumnTooltip(vv)">
                                            <span class="table-level2-label-text" :ref="`tooltip_text_${vv.id}`" v-html="vv.milestoneName"></span>
                                        </div>
                                    </el-tooltip>
                                    <div v-show="!vv.accessFlag" class="onlyforkpmg-tip">{{ $t('for_kpmg_only') }}</div>
                                </div>
                            </template>

                            <!-- 状态 三级表头-->
                            <el-table-column width="120" align="center">
                                <template #header>
                                    <span>{{ $t('sas_status') }}</span>
                                    <!-- 状态下拉筛选 -->
                                    <el-dropdown trigger="click" @command="onStatusFilterClick">
                                        <span class="el-dropdown-link">
                                            <i :class="['table-level2-icon', 'el-icon-arrow-down', vv.where.status > 0 ? 'el-icon-arrow-down-active' : '']"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-for="(status, statusK) in statusOption"
                                                :key="statusK"
                                                :command="{v: vv, s: status}">
                                                <img :src="getIconSvg(status.icon)" width="100%" />
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                                <template slot-scope="{row}">
                                    <el-tooltip placement="top" effect="light" :disabled="(!row.mileStoneRecordList[`${vv.id}`].stateChangedTime && !row.mileStoneRecordList[`${vv.id}`].stateChangeBy && calcRowStatusDisable(row, vv) !== -3)">
                                        <template slot="content">
                                            <span v-if="(calcRowStatusDisable(row, vv) == -3)">
                                                {{ $t('milestone_cannot_update_tooltip') }}
                                            </span>
                                            <span v-else>
                                                <span v-show="row.mileStoneRecordList[`${vv.id}`].stateChangedTime">{{ $t('ACCOUNT_STATUS_UPDATE_BY') }} {{ row.mileStoneRecordList[`${vv.id}`].stateChangedTime | formatDateTime }} </span>
                                                <span v-show="row.mileStoneRecordList[`${vv.id}`].stateChangeBy">{{ $t('ACCOUNT_STATUS_SPREAD_BY') }} {{ row.mileStoneRecordList[`${vv.id}`].stateChangeBy }}</span>
                                            </span>
                                        </template>
                                        <el-dropdown trigger="click" @command="onStatusCellChange" :disabled="(calcRowStatusDisable(row, vv) < 0)">
                                            <span class="el-dropdown-link">
                                                <img :src="getIconsvgByRow(row, vv)" width="100%" />
                                                <i class="el-icon-caret-bottom el-icon--right"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item
                                                    v-for="(status, statusK) in statusOption"
                                                    :key="statusK"
                                                    :command="{row, status, vv}">
                                                    <img class="status-dropdown-img" :src="getIconSvg(status.icon)" width="100%"/>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </el-tooltip>
                                </template>
                            </el-table-column>

                            <!-- 日期 三级表头 -->
                            <el-table-column v-if="vv.targetTimeSelected" width="170" align="center">
                                <template #header>
                                    <!-- 日期下拉 -->
                                    <span @click="showCellDatePicker(vv)">
                                        <i :class="['table-level2-icon', 'el-icon-date', vv.where.targetTime ? 'el-icon-arrow-down-active' : '']" v-show="getUser.userType == '1'"></i>
                                        <el-date-picker
                                            type="date"
                                            :clearable="false"
                                            size="mini"
                                            value-format="yyyy-MM-dd"
                                            v-model="vv.where.targetTime"
                                            @change="(e) => onTargetTimeFilterChange(e, vv)"
                                            style="visibility: hidden; position:absolute; top:0; left:0; z-index:-1;"
                                            :ref="`cellDatePicker_${vv.id}`"
                                            v-show="getUser.userType == '1'">
                                        </el-date-picker>
                                        {{ $t('target_datetime') }}
                                    </span>

                                    <!-- 日期筛选 -->
                                    <DatePickerPopover
                                        style="margin-right: 5px;"
                                        :value.sync="vv.where.targetTimeFilter"
                                        :hidePopperSearch="(e) => onTargetTimeWhereFilterChange(e, vv)">
                                    </DatePickerPopover>
                                </template>
                                <template slot-scope="scope">
                                    <el-date-picker
                                        class="cell-targetDate-picker"
                                        type="date"
                                        :placeholder="$t('table_placeholder_deadline')"
                                        size="mini"
                                        value-format="yyyy-MM-dd"
                                        v-model="scope.row.mileStoneRecordList[`${vv.id}`].targetDate"
                                        @change="(e) => onTargetDateCellChange(e, scope.row, vv)"
                                        :disabled="([1, 4].includes(scope.row.mileStoneRecordList[`${vv.id}`].state) || getUser.userType == '2')">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table-column>

                    <!-- 文件列表 -->
                    <el-table-column :label="$t('FORM_LABEL_attachmentList_short')" width="120" fixed="right" align="center">
                        <template #header>
                            <div class="header-with-popup">
                                {{ $t('TABLE_HEADER_fileNameList') }}
                                <el-popover
                                        placement="bottom"
                                        trigger="click"
                                        :visible-arrow="false"
                                        @hide="hidePopperSearch">
                                    <template #reference>
                                        <div class="th-filter-down">
                                            <i :class="['el-icon-arrow-down', fileName ? 'el-icon-arrow-down-active' : '']"></i>
                                        </div>
                                    </template>

                                    <template>
                                        <el-input
                                            class="input-with-select"
                                            v-model="fileName"
                                            size="medium"
                                            :placeholder="$t('fileNameKeyword')"
                                            clearable
                                        ></el-input>
                                    </template>
                                </el-popover>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="attachment-count" @click="onFileNumClick(scope.row)">
                                {{ scope.row.attachmentBOList && scope.row.attachmentBOList.length ? scope.row.attachmentBOList.length : 0 }}
                            </div>
                        </template>
                    </el-table-column>

                    <!-- 上传 -->
                    <el-table-column :label="$t('COMMON_UPLOAD')" width="70" fixed="right" align="center">
                        <template slot-scope="scope">
                            <i :class="['wl-icon-upload', 'el-icon-upload', !hasPermission('upload') ? 'upload-icon-disabled' : '']" @click="onUploadClick(scope.row)"></i>
                        </template>
                    </el-table-column>

                    <!-- 留言 -->
                    <el-table-column :label="$t('TABLE_HEAD_COMMENTS')" width="85" align="center" fixed="right">
                        <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEAD_COMMENTS') }}
                            <DatePickerPopover
                                :value.sync="commentDate"
                                :hidePopperSearch="hidePopperSearch"
                            ></DatePickerPopover>
                        </div>
                    </template>
                        
                        <template slot-scope="scope">
                        
                        <div class="flex  item-center justify-center">
                        <i
                            :class="[
                                scope.row.todayCommentCount > 0  ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                'el-icon-s-comment'
                            ]"
                            @click="onCommentClick(scope.row)"
                        ></i>
                        <span v-if="scope.row.todayCommentCount"> 
                            <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                            <span>/</span> 
                        </span>
                        <span v-if="scope.row.messageCount > 0 "> {{ scope.row.messageCount }}</span>
                    </div>
                </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="multi-func" v-show="tableSelect.show">
                <el-button size="mini" @click="cancelBatchFunc">{{ $t('btn_cancel') }}</el-button>
                <el-button v-show="['batch_download', 'export_file_log'].includes(tableSelect.mode)" class="wl-green" size="mini" @click="openBatchDownloadDialog" :disabled="tableSelect.value.length == 0">{{ $t( { batch_download: 'BATCH_DOWNLOAD', export_file_log: 'BATCH_export' }[tableSelect.mode]) }}</el-button>
                <el-button v-show="['send_email_progress', 'send_email_draft'].includes(tableSelect.mode)" class="wl-green" size="mini" @click="openNoticeEmailDialog" :disabled="tableSelect.value.length == 0">{{ $t('PAGE_CLIENTUSER_EMAIL') }}</el-button>
            </div>
            <div class="pagination">
                <el-pagination
                    :current-page="page"
                    class="wl-pagination"
                    :page-size="limit"
                    @current-change="(v) => { page = v; getList()}"
                    layout="prev, pager, next, slot, total"
                    :total="total">
                        <span>
                            <el-select v-model="limit" @change="(e) => {page = 1; limit = e; getList()}">
                                <el-option
                                    v-for="v in pageOptions"
                                    :key="v.value"
                                    :label="v.label"
                                    :value="v.value">
                                </el-option>
                            </el-select>
                        </span>
                </el-pagination>
            </div>
            </div>
            

            
            </div>
            <entity ref="entity" :onAdd="getList" :entityData="entityData" />
            <TableColumnControl ref="tableColCtrl" :show.sync="columnControl.show" :treeData.sync="tableColumns" :parentPageLoadColumn="getColumnStatus" :anyHidden.sync="anyHidden"></TableColumnControl>
            <CommentsDialog ref="commentsDlg" :reloadParents="getList" :statuId="commentsDialog.statusId" v-if="commentsDialog.show" :show.sync="commentsDialog.show" :siteId="siteId"></CommentsDialog>
            <Upload ref="Upload" v-if="upload.show" :rowData="upload.rowData" :secondMilestoneId="upload.secondMilestoneId" @afterUploadAllFinish="afterUploadAllFinish"></Upload>
            <FileList :show.sync="fileList.show" :filelist="fileList.list" :reloadList="getList"></FileList>
            <BatchSelectFile :show.sync="tableSelect.showFileTable" :filelist="tableSelect.fileList" @closeBatch="closeBatch" :milestoneColumns="tableColumns" :mode="tableSelect.mode"></BatchSelectFile>
            <Dashboard :tableColumns="tableColumns" :allEntityIds="this.allEntityIds" :filterChange="getList" :tableFilter="tableFilter" ref="dashboardRef"></Dashboard>
            <sendNoticeEmail v-if="getUser.userType == '1'" :show.sync="tableSelect.showEmailDialog" :selectList="tableSelect.value" :reloadList="getList" :mode="tableSelect.mode"></sendNoticeEmail>
    </div>
    
</template>
<script>
import Dashboard from './Components/Dashboard'
import TableColumnControl from './Components/TableColumnControl'
import API from '@/api'
import { mapGetters } from 'vuex'
import { userEntity } from '@/mixins/getUserEntity.js'
import { userPermission } from '@/mixins/userPermission.js'
import Entity from '@/components/common/entity'
import { loading, dateFormat, isIE } from '@/utils'
import CommentsDialog from './Components/CommentsDialog'
import Upload from './Components/Upload'
import FileList from './Components/FileList'
import BatchSelectFile from './Components/BatchSelectFile'
import sendNoticeEmail from './Components/SendNoticeEmail'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import { treeToList } from '@/utils/formatTree'
import NewComments from '@/components/common/NewComments.vue'

export default {
    name: 'SASIndex',
    components: { Entity, Dashboard, TableColumnControl, CommentsDialog, Upload, FileList, BatchSelectFile, sendNoticeEmail, GuidanceTooltip, DatePickerPopover, NewComments },
    data() {return {
        tableKey: 'a',
        tableColumns: [],
        tableData: [],
        tableLoading: false,
        page: 1,
        limit: 10,
        total: 0,
        // 分页器选项
        pageOptions: [
            {label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10},
            { label: '50/' + this.$t('page'), value: 50 },
            { label: '100/' + this.$t('page'), value: 100 },
        ],
        statusOption: [
            {
                status: 1,
                icon: 'icon-not-applicable',
                label: 'ACCOUNT_STATUS_NOT_APPLICABLE'
            },
            {
                status: 3,
                icon: 'icon-not-started',
                label: 'ACCOUNT_STATUS_NOT_START'
            },
            {
                status: 2,
                icon: 'icon-in-progress',
                label: 'ACCOUNT_STATUS_NOT_PROGRESS'
            },
            {
                status: 4,
                icon: 'icon-completed',
                label: 'ACCOUNT_STATUS_NOT_COMPLETE'
            }
        ],
        columnControl: {
            show: false,
            treeData: []
        },
        anyHidden: false,
        commentsDialog: {
            statusId: '',
            show: false
        },
        upload: {
            fileList: [],
            show: false,
            rowData: {}
        },
        fileList: {
            show: false,
            list: []
        },
        tableSelect: {
            value: [],
            mode: '',       // batch_download 批量下载      export_file_log 导出文件记录    send_email_progress  发邮件1    send_email_draft 发邮件2
            show: false,
            showFileTable: false,
            fileList: []
        },
        tableSelectOri: {
            value: [],
            mode: '',       // batch_download 批量下载      export_file_log 导出文件记录    send_email_progress  发邮件1    send_email_draft 发邮件2
            show: false,
            showFileTable: false,   // 批量下载、导出文件记录的弹窗
            fileList: [],
            showEmailDialog: false
        },
        fileName: '',
        statutoryItemsFilename:`Statutory Accounts Status _ statutory list@${dateFormat(new Date(), 'yyyyMMdd')}.xlsx`,
        commentDate:[]
    }},
    mixins: [userEntity, userPermission],
    async mounted() {
        await this.getUserEntity('15')
        this.$store.commit('common/setEntityIds', this.allEntityIds)
        if (await this.getTableColumn()) {
            await this.querySavedCondition()
            this.$nextTick(() => {
                this.$refs.SasTable.doLayout()
                this.tableKey = `${Math.random()}`
            })
            await this.getList()

            if(this.$route.query.openDashboard == '1'){
                this.$nextTick(()=>{
                    this.$refs.dashboardRef.openDraw()
                })  
            }
        }

        
    },
    methods: {
        hidePopperSearch() {
            this.page = 1
            this.getList()
        },
        showCellDatePicker(vv) {
            this.$refs[`cellDatePicker_${vv.id}`][0].showPicker()
        },
        querySavedCondition() {
            const form = new FormData()
            form.append('siteId', this.getSite.siteId)
            return API.status.querySavedCondition(form).then(res => {
                if (res.data === null) {
                    this.clearFilter()
                    return
                }
                const saveCondition = JSON.parse(res.data)
                this.$store.commit('common/setEntityIds', saveCondition.entityId)
                this.tableColumns.forEach(v => {
                    if (v.childMilestoneBO !== null) {
                        v.childMilestoneBO.forEach(vv => {
                            if (!saveCondition || !saveCondition.milestoneQueryList) return
                            const findCondition = saveCondition.milestoneQueryList.find(val => val.milestoneId == vv.id)
                            if (findCondition && findCondition.status && findCondition.status > 0) {
                                vv.where.status = findCondition.status
                            }
                            if (findCondition && findCondition.targetTime) {
                                vv.where.targetTimeFilter = findCondition.targetTime
                            }
                        })
                    }
                })
                this.page = saveCondition.pageNum
                this.limit = saveCondition.pageSize > 500 ? 10 : saveCondition.pageSize
            })
        },
        clearFilter() {
            this.$store.commit('common/setEntityIds', this.allEntityIds)
            this.tableColumns.forEach(v => {
                v.childMilestoneBO.forEach(vv => {
                    vv.where = {
                        status: 0,
                        targetTime: null,
                        targetTimeFilter: ['', '']
                    }
                })
            })
            this.fileName = ''
            this.commentDate = []
            this.page = 1
            this.limit = 10
            this.getList()
        },
        /**
         * 表格内日期单元格修改
         * @param {*} e     修改后的值
         * @param {*} row   当前行的数据
         * @param {*} vv    二级表头数据
         */
        onTargetDateCellChange(e, row, vv) {
            API.status.updateStatutoryRecordDate({
                siteId: this.getSite.siteId,
                statutoryId: [row.id],
                milestone:
                    {
                        milestoneId: vv.id,
                        targetDate: e,
                        status: row.mileStoneRecordList[vv.id].state
                    }
            }).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    row.mileStoneRecordList[vv.id].oldTargetDate = row.mileStoneRecordList[vv.id].targetDate
                } else {
                    row.mileStoneRecordList[vv.id].targetDate = row.mileStoneRecordList[vv.id].oldTargetDate
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {})
        },

        /**
         * 表格内单元格的状态变更
         * @param {*} e.row     当前行数据
         * @param {*} e.status  变更后的状态
         * @param {*} e.vv      二级表头
         */
        onStatusCellChange(e) {
            if (this.getUser.userType == '2') return
            if ([1, 4].includes(e.status.status)) {
                this.$confirm(this.$t('milestone_completion_alert'), this.$t('COMMON_TIP'), {
                        confirmButtonText: this.$t('btn_confirm'),
                        cancelButtonText: this.$t('btn_cancel'),
                        type: 'warning'
                    }).then(() => {
                    const { row, status, vv } = e
                    API.status.updateStatutoryRecord({
                        siteId: this.getSite.siteId,
                        statutoryId: [row.id],
                        milestone:
                            {
                                milestoneId: vv.id,
                                status: status.status
                            }
                    }).then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            row.mileStoneRecordList[vv.id].state = status.status
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    }).catch(e => {
                        console.error(e);
                        this.$message.error(this.$t('SYS_USER_003'))
                    }).finally(() => {})
                })
            } else {
                const { row, status, vv } = e
                API.status.updateStatutoryRecord({
                    siteId: this.getSite.siteId,
                    statutoryId: [row.id],
                    milestone:
                        {
                            milestoneId: vv.id,
                            status: status.status
                        }
                }).then(res => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        row.mileStoneRecordList[vv.id].state = status.status
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                }).catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                }).finally(() => {})
            }
        },

        /**
         * 批量操作 取消
         */
        cancelBatchFunc() {
            this.tableSelect = Object.assign({}, this.tableSelectOri)
        },

        /**
         * 打开批量下载弹窗
         */
        openBatchDownloadDialog() {
            this.tableSelect.showFileTable = true
        },

        /**
         * 打开发送邮件弹窗
         */
         openNoticeEmailDialog() {
            this.tableSelect.showEmailDialog = true
         },

        /**
         * 两个发邮件按钮，显示表格选择列
         */
        onNoticeProgressClick() {
            this.$refs.SasTable.clearSelection()
            this.tableSelect = {
                ...Object.assign({}, this.tableSelectOri),
                mode: 'send_email_progress',
                show: true
            }
        },
        onNoticeDraftClick() {
            this.$refs.SasTable.clearSelection()
            this.tableSelect = {
                ...Object.assign({}, this.tableSelectOri),
                mode: 'send_email_draft',
                show: true
            }
        },
        /**
         * 点击批量下载按钮，显示表格的选择列
         */
        onBatchDownloadClick() {
            this.$refs.SasTable.clearSelection()
            this.tableSelect = {
                ...Object.assign({}, this.tableSelectOri),
                mode: 'batch_download',
                show: true
            }
        },

        /**
         * 点击导出文件记录按钮，显示表格的选择列
         */
        onExportFileLogClick() {
            this.$refs.SasTable.clearSelection()
            this.tableSelect = {
                ...Object.assign({}, this.tableSelectOri),
                mode: 'export_file_log',
                show: true,
            }
        },

        /**
         * 表格的选择列变化，将值更新上去
         * 同时把被选了的文件更新到另一个值上
         *
         * @param {*} e     当前选择的列们
         */
        onTableSelectChange(e) {
            e.map(childItem => {
                childItem.attachmentBOList.map(v => {
                    // 计算每个文件属于的里程碑对应的当前状态
                    const find = this.milestoneSort.find(vv => vv.id == v.milestoneId)
                    if (find) {
                        const findRowMilestone = Object.values(childItem.mileStoneRecordList).find(vv => vv.milestoneId == find.id)
                        if (findRowMilestone) {
                            v.milestoneRowValue = findRowMilestone
                        } else {
                            v.milestoneRowValue = null
                        }
                    } else {
                        v.milestoneRowValue = null
                    }

                    return v
                })
            })
            this.tableSelect.value = e
            this.tableSelect.fileList = e.reduce((pre, cur) => {
                return [
                    ...cur.attachmentBOList.map(v => ({...v, cur})),
                    ...pre
                ]
            }, [])
        },

        /**
         * 折叠列变化
         *
         * @param {*} v         一级表头
         * @param {*} collapse  折叠状态
         */
        switchCollapse(v, collapse) {
            this.tableLoading = true
            v.collapse = !collapse
            this.$nextTick(() => {
                this.$refs.SasTable.doLayout()
                this.tableKey = `${Math.random()}`
            })
            API.common.saveFixColumns({
                siteId: this.getSite.siteId,
                tableKey: 'SAS_collapse',
                hiddenColumns: this.tableColumns.filter(v => v.collapse).map(v => v.id)
            }).finally(() => {
                this.tableLoading = false
            })
        },

        /**
         * 文件数量被点击，显示文件弹窗
         * @param {*} row   当前行
         */
        onFileNumClick(row) {
            if (row.attachmentBOList.length == 0) return
            row.attachmentBOList.map(v => {
                // 计算每个文件属于的里程碑对应的当前状态
                const find = this.milestoneSort.find(vv => vv.id == v.milestoneId)
                if (find) {
                    const findRowMilestone = Object.values(row.mileStoneRecordList).find(vv => vv.milestoneId == find.id)
                    if (findRowMilestone) {
                        v.milestoneRowValue = findRowMilestone
                    } else {
                        v.milestoneRowValue = null
                    }
                } else {
                    v.milestoneRowValue = null
                }

                return v
            })
            this.fileList.show = true
            this.fileList.list = row.attachmentBOList.sort((a, b) => Date.parse(new Date(b.createDate)) - Date.parse(new Date(a.createDate)))

        },

        /**
         * 导出法定审计报告
         */
        async onExportClick() {
            const _loading = loading()
            _loading.download()
            try {
                const res = await API.status.exportStatutoryList({ siteId: this.getSite.siteId })
                if (/application\/json/.test(res.type)) {
                    let reader = new FileReader()
                    reader.onload = e => {
                        if (e.target.readyState === 2) {
                            let resJson = {}
                            resJson = JSON.parse(e.target.result)
                            this.$message.error({duration: 5000, message: this.$t(resJson.code)})
                        }
                    }
                    reader.readAsText(res)
                } else if (/application\/octet-stream/.test(res.type)) {

                    let blob = new Blob([res])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, this.statutoryItemsFilename)
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', this.statutoryItemsFilename)
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            } catch (e) {
                console.error(e)
                this.$t('COMMON_001')
            }

            _loading.close()
        },

        /**
         * 获取隐藏列状态
         */
        getColumnStatus() {
            API.common.queryFixColumns({
                siteId: this.getSite.siteId,
                tableKey: 'SAS'
            }).then(res => {
                if (res.code == '1' && res.data && res.data.hiddenColumns && res.data.hiddenColumns.length > 0) {
                    const hiddenColumns = res.data.hiddenColumns.replace('[', '').replace(']', '').split(', ').map(v => `${v}`)
                    this.tableColumns = this.tableColumns.map(v => {
                        if (hiddenColumns.includes(v.id)) {
                            v.show = false
                        } else {
                            v.show = true
                        }
                        v.childMilestoneBO.map(vv => {
                            if (hiddenColumns.includes(vv.id)) {
                                vv.show = false
                            } else {
                                v.show = true
                                vv.show = true
                            }
                            return vv
                        })
                        return v
                    })
                }
                this.$refs.tableColCtrl.getColumnStatus()
            })
        },

        /**
         * 显示隐藏列弹窗
         */
        onTableColumnControlClick() {
            if (this.tableColumns.length > 0) this.columnControl.show = true
        },

        /**
         * 计算一行的二级里程碑id，上传时候要用的
         * 规则：
         *
         * 上一个是已完成(1)，或者不适用(4)的 第一个未开始(3)或者 进行中(2)
         * @param {*} row
         */
        calcSecondMilestoneId(row) {
            const tableColumnsSortArr = []
            this.tableColumns.sort((a, b) => a.sort - b.sort).forEach(v => {
                v.childMilestoneBO.sort((a, b) => a.sort - b.sort).forEach(vv => {
                    tableColumnsSortArr.push(vv)
                })
            })

            const find = tableColumnsSortArr.find((v, k) => {
                if (k == 0) return false

                if (
                    [1, 4].includes(row.mileStoneRecordList[`${tableColumnsSortArr[k - 1].id}`].state) &&
                    [3, 2].includes(row.mileStoneRecordList[`${v.id}`].state)
                ) {
                    return true
                }
            })

            return find && find.id ? find.id : tableColumnsSortArr[0].id
        },

        /**
         * 上传按钮被点击
         * @param {*} row   当前行
         */
        onUploadClick(row) {
            if (!this.hasPermission('upload')) return
            this.upload = {
                show: true,
                rowData: row,
                secondMilestoneId: this.calcSecondMilestoneId(row)
            }
        },
        afterUploadAllFinish() {
            this.upload.show = false
            this.getList()
        },

        /**
         * 评论按钮被点击
         * @param {*} row   当前行
         */
        onCommentClick(row) {
            this.commentsDialog = {
                statusId: row.id,
                show: true
            }
        },

        /**
         * 计算一级表头的tooltip
         *
         * @param {*} vv
         */
        calcShowTableColumnTooltip(vv) {
            const ref = this.$refs[`tooltip_text_${vv.id}`][0]
            if (!ref || !ref.parentNode) return
            const parentWidth = ref.parentNode.offsetWidth
            const contentWidth = ref.offsetWidth
             
            vv.showTableColumnTooltip = contentWidth > parentWidth
        },

        /**
         * 表头的日期被修改，批量更新
         *
         * @param {*} e     新的日期
         * @param {*} vv    二级表头
         */
        onTargetTimeFilterChange(e, vv) {
            const statutoryId = this.tableData.filter(v => ![1, 4].includes(v.mileStoneRecordList[vv.id].state)).map(v => v.id)
            if (statutoryId.length == 0) {
                this.$message.error(this.$t('none_of_update_data'))
                return
            }
            API.status.updateStatutoryRecordDate({
                siteId: this.getSite.siteId,
                statutoryId,
                milestone:
                    {
                        milestoneId: vv.id,
                        targetDate: e
                    }
            }).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {
                vv.where.targetTime = ''
            })
        },


        /**
         * 表头的日期筛选被选择，触发筛选
         *
         * @param {*} e.v   二级表头
         * @param {*} e.s   选的状态
         *
         */
        onTargetTimeWhereFilterChange(e, vv) {
             
            vv.where.targetTimeFilter = e
            this.getList()
        },

        /**
         * 表头的状态被点击，触发筛选
         *
         * @param {*} e.v   二级表头
         * @param {*} e.s   选的状态
         *
         */
        onStatusFilterClick(e) {
            e.v.where.status = e.s.status
            this.getList()
        },

        /**
         * 页码变化
         * @param {*} current
         */
        onCurrentPageChange(current) {
            this.pagination.current = current
            this.queryInsightsList()
        },

        /**
         * 获取表头
         *
         * 在进入页面的时候，如果这个方法返回 true，则继续获取列表
         */
        async getTableColumn() {
            /**
             * 获取折叠列
             */
            const { code: code1, data: data1 } = await API.common.queryFixColumns({
                siteId: this.getSite.siteId,
                tableKey: 'SAS_collapse'
            })
            let collapseColumns = []
            if (code1 == '1' && data1 && data1.hiddenColumns && data1.hiddenColumns.length > 0) {
                collapseColumns = data1.hiddenColumns.replace('[', '').replace(']', '').split(', ').map(v => `${v}`)
            }

            /**
             * 获取表头
             *
             */
            const {code, data} = await API.status.listTableColumn({ siteId: this.getSite.siteId })
            if (code !== '1') {
                this.$message({
                    type: 'error',
                    message: this.$t(code)
                })
                return
            }

            this.tableColumns = data.map(v => {
                v.collapse = !!collapseColumns.includes(v.id)
                v.show = true
                v.childMilestoneBO = v.childMilestoneBO.map((vv, kk) => {
                    vv.showTableColumnTooltip = false
                    vv.show = true
                    vv.where = {
                        status: 0,
                        targetTime: null,
                        targetTimeFilter: ['', '']
                    }
                    return vv
                })
                return v
            })

            /**
             * 异步获取隐藏列
             */
            this.getColumnStatus()
            return true
        },

        closeBatch(flag) {
            console.log(2222222)
            this.tableSelect.showFileTable = false
            if(flag) {
               this.getList()
            }
        },

        /**
         * 获取列表
         */
        async getList() {
            if (!this.getIfKpHasAccess) return
            this.tableLoading = true
            const {code, data} = await API.status.getStatusList(this.tableFilter)
            this.tableLoading = false
            if (code !== '1') {
                this.$message({
                    type: 'error',
                    message: this.$t(code)
                })
                return
            }

            this.total = data.total
            this.tableData = data && data.records && data.records.length > 0 ? data.records.map(v => {
                let mileStoneRecordList = {}
                v.mileStoneRecordList.forEach(vv => {
                    mileStoneRecordList[`${vv.milestoneId}`] = {
                        ...vv,
                        oldTargetDate: vv.targetDate
                    }
                })
                v.mileStoneRecordList = mileStoneRecordList
                return v
            }) : []
        },
        calcRowStatusDisable(row, vv) {
            // 客户端不让修改
            if (this.getUser.userType == '2') {
                return -1
            }
            // 已完成和不适用的时候不让修改
            if ([1, 4].includes(row.mileStoneRecordList[`${vv.id}`].state)) {
                return -2
            }
            // 上一个里程碑是已完成的时候，当前才允许修改
            const curCol = this.milestoneSort.findIndex(v => v.id == vv.id)
            // 第一个里程碑永远让改
            if (curCol == 0) {
                return 1
            }
            const preCol = this.milestoneSort[curCol - 1]
            if ([1, 4].includes(row.mileStoneRecordList[`${preCol.id}`].state)) {
                return 1
            }
            return -3
        },
        getIconsvgByRow(row, vv) {
            const find = this.statusOption.find(v => v.status === row.mileStoneRecordList[`${vv.id}`].state)
            return find && find.icon ? this.getIconSvg(find.icon) : ''
        },
        getIconSvg(icon) {
            return require(`@/assets/img/${icon}.svg`)
        },
        openEntity() {
            this.$refs.entity.updateDrawer()
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
            getIfKpHasAccess: 'getIfKpHasAccess',
            getEntityIdsSelectAllTag: 'getEntityIdsSelectAllTag',
        }),
        milestoneSort() {
            return this.tableColumns.reduce((pre, cur) => {
                pre = [...pre, ...cur.childMilestoneBO]
                return pre
            }, [])
        },
        milestoneQueryList() {
            let milestoneQueryList = []
            this.tableColumns.forEach(v => {
                v.childMilestoneBO.forEach(vv => {
                    if (vv.where.status === 0 && vv.where.targetTime === null && vv.where.targetTimeFilter.filter(v => !!v).length != 2) return
                    let where = { milestoneId: vv.id }
                    if (vv.where.status !== 0) {
                        where.status = vv.where.status
                    }
                    if (vv.where.targetTimeFilter.filter(v => !!v).length == 2) {
                        where.targetTime = vv.where.targetTimeFilter
                    }
                    milestoneQueryList.push(where)
                })
            })
            return milestoneQueryList
        },
        tableFilter() {
            return {
                siteId: this.getSite.siteId,
                pageSize: this.limit,
                pageNum: this.page,
                entityId: this.getEntityIds,
                milestoneQueryList: this.milestoneQueryList,
                fileName: this.fileName,
                startCommentDate: this.commentDate && this.commentDate[0] ? dateFormat(new Date(this.commentDate[0]), 'yyyy-MM-dd') : null,
                endCommentDate: this.commentDate && this.commentDate[1] ? dateFormat(new Date(this.commentDate[1]), 'yyyy-MM-dd') : null,
            }
        },
        entityDataTotalSize(){
            const flatTree = treeToList(this.entityData).filter(item=>!item.disabled)
            return flatTree.length
        },
        siteId() {
            return this.getSite.siteId
        }
    },
    watch: {

    }
}
</script>
<style scoped>
.sas-container {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 20px;
    /* background: white; */
    border-radius: 5px;
    display: flex;
    flex-direction: column;
}

.sas-container .row {
    display: flex;
    flex-direction: row;
    font-size: 12PX;
    height: 20px;
}

.sas-container .row1 {
    align-items: center;
    justify-content: space-between;
    height: 44px;
    margin-top: 20px;
}
.sas-container .row1 .row1-tip {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
}
.sas-container .row1 .row1-tip-hidden {
    visibility: hidden;
}
.sas-container .row1 .row1-tip .icon-tip{
    font-size: 36px;
    color: #00338d;
    margin-right: 10px;
}

.sas-container .row2 .table-column-control {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}
.sas-container .row2 .table-column-control .icon {
    width: 15PX;
    height: 15PX;
}
.sas-container .row2 .table-column-control .text {
    margin-left: 5px;
}
.sas-container .row2 .table-column-control-active .text {
    font-weight: 600;
    color: #5879eb;
}

.sas-container .row2 {
    align-items: center;
    justify-content: space-between;
    min-height: 44px;
    margin-bottom: 5px;
    flex-wrap: wrap;
}

.sas-container .row2:nth-of-type(1) {
    border-bottom: solid 1px #e3e4e6;
}
.sas-container .row2 .left {
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.sas-container .row2 .left .status {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}
.sas-container .row2 .left .status .icon {
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.sas-container .row2 .left .status .icon img {
    width: 15px;
    height: 15px;
}
.sas-container .row2 .left .status .text {
    margin-left: 5px;
}
.sas-container .row2 .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}
.sas-container .row2 .right .row2-right-btn {
    margin-bottom: 5px;
}
.sas-container .row2 .right .split {
    height: 15px;
    width: 1px;
    border-left: solid 1px #ccced2;
    margin: 0 10px;
}
.sas-container .row2 .right .clean-filter {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12PX;
}
.sas-container .row2 .right .clean-filter img {
    margin-right: 5px;
}

.sas-container .table {
    height: calc(100% - 172px);
}
.sas-container .table-multiselect {
    height: calc(100% - 222px);
}
.sas-container .pagination {
    height: 44px;
    margin: 0;
    margin-right: 20px;
    margin-bottom: 20px;
}
.el-dropdown-link {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.el-dropdown-link img {
    width: 15px;
    height: 15px;
}
.table-level2-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.table-level2-header .table-level2-label {
    display: block;
    font-size: 12PX;
    font-weight: 700;
    width: 100%;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.table-level2-icon {
    font-size: 12px;
    margin-left: 10px;
}

.table-level2-icon.el-icon-date {
    color: #4984ec;
}
.attachment-count {
    font-size: 12;
    color: #4883ec;
}
.attachment-count:hover {
    text-decoration: underline;
    cursor: pointer;
}
.wl-icon-upload {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}
.upload-icon-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
}
.wl-icon-messageBoard {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}

.wl-icon-messageBoardNull {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}
.level1-table-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 30px;
}
.level1-table-header .level1-table-header-text {
    width: calc(100% - 50px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    line-height: 42px;
}
.level1-table-header .fold-btn {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 5px;
    top: 7px;
    border: solid 1px #b2c1dc;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.level1-table-header .fold-btn i {
    font-size: 8px;
    cursor: pointer;
}
.onlyforkpmg-tip {
    color: #fd349c;
}
.multi-func {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    margin-top: 10px;
}
.cell-targetDate-picker {
    width: 130px !important;
}
::v-deep .table-row {
    height: 50px;
}
.status-dropdown-img {
    width: 15px;
    height: 15px;
}
::v-deep .el-table th.el-table__cell>.cell {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
</style>
